import { c as _c } from "react/compiler-runtime";
import type { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import { FOLLOW_BTN_SVG_CLASSES } from "@/components/user/utils/UserFollowBtn";
import type { ApiIdentitySubscriptionActions } from "@/generated/models/ApiIdentitySubscriptionActions";
import { ApiIdentitySubscriptionTargetAction } from "@/generated/models/ApiIdentitySubscriptionTargetAction";
export const DEFAULT_SUBSCRIPTION_BODY: ApiIdentitySubscriptionActions = {
  actions: Object.values(ApiIdentitySubscriptionTargetAction).filter(i => i !== ApiIdentitySubscriptionTargetAction.DropVoted)
};
export function FollowBtnCheckIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="tw-h-3 tw-w-3" width="17" height="15" viewBox="0 0 17 15" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function FollowBtnPlusIcon(t0) {
  const $ = _c(3);
  const {
    size
  } = t0;
  const t1 = FOLLOW_BTN_SVG_CLASSES[size];
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}